import React from "react";
import "../styles/searchSuggest.css";

/**
 * Renders the categories/businesses typeahead dropdown. Same component used
 * by HeroSection (home page) and FilterBar (search-results page) so the
 * global search-suggestion behaviour is identical everywhere it appears.
 */
export default function SearchSuggestDropdown({
    suggestions,
    flatItems,
    loading,
    activeIndex,
    onHoverIndex,
    onSelectCategory,
    onSelectBusiness,
}) {
    const cats = suggestions?.categories || [];
    const bizs = suggestions?.businesses || [];

    return (
        <div className="dn-suggest shadow">
            {loading && flatItems.length === 0 && (
                <div className="dn-suggest-empty text-muted">
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Searching…
                </div>
            )}

            {cats.length > 0 && (
                <>
                    <div className="dn-suggest-head">Categories</div>
                    {cats.map((c, idx) => (
                        <button
                            type="button"
                            key={`cat-${c.id}`}
                            className={`dn-suggest-item ${activeIndex === idx ? "active" : ""}`}
                            onMouseEnter={() => onHoverIndex && onHoverIndex(idx)}
                            onClick={() => onSelectCategory(c)}
                        >
                            <i className="bi bi-search dn-suggest-icon"></i>
                            <span className="dn-suggest-label">{c.label}</span>
                            <span className="dn-suggest-tag">Category</span>
                        </button>
                    ))}
                </>
            )}

            {bizs.length > 0 && (
                <>
                    <div className="dn-suggest-head">Businesses</div>
                    {bizs.map((b, idx) => {
                        const flatIdx = cats.length + idx;
                        return (
                            <button
                                type="button"
                                key={`biz-${b.id}`}
                                className={`dn-suggest-item ${activeIndex === flatIdx ? "active" : ""}`}
                                onMouseEnter={() => onHoverIndex && onHoverIndex(flatIdx)}
                                onClick={() => onSelectBusiness(b)}
                            >
                                <img
                                    className="dn-suggest-thumb"
                                    src={b.profilepics && b.profilepics.trim() !== "" ? b.profilepics : "/assets/defaultList.jpg"}
                                    alt={b.title}
                                    onError={(e) => { e.target.onerror = null; e.target.src = "/assets/defaultList.jpg"; }}
                                />
                                <span className="dn-suggest-biz">
                                    <span className="dn-suggest-label">
                                        {b.title}
                                        {Number(b.is_verified) === 1 && (
                                            <i className="bi bi-patch-check-fill text-primary ms-1" title="Verified" aria-label="Verified"></i>
                                        )}
                                    </span>
                                    <span className="dn-suggest-sub">
                                        {b.rating ? (
                                            <>
                                                <span className="dn-suggest-rating">{Number(b.rating).toFixed(1)} ★</span>
                                                {b.review_count ? ` (${b.review_count})` : ""}
                                                {(b.category || b.area) ? " · " : ""}
                                            </>
                                        ) : null}
                                        {b.category || ""}{b.category && b.area ? " · " : ""}{b.area || ""}
                                    </span>
                                </span>
                            </button>
                        );
                    })}
                </>
            )}

            {!loading && flatItems.length === 0 && (
                <div className="dn-suggest-empty text-muted">No matches found</div>
            )}
        </div>
    );
}
